import '../assets/StickyImage.css';
import { defineComponent, useCssVars, unref, ref, computed, watchEffect, openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, createVNode, vShow, createCommentVNode, defineAsyncComponent, onMounted, createElementBlock, Fragment, withModifiers, normalizeClass, normalizeStyle, TransitionGroup, provide } from 'vue';
import { D as DeviceKind, g as DefaultStep, e as ToolModuleKind, a as ToolLayoutKind, d as ToolPosition } from './maps.nxkzRTum.js';
import { u as useElementSize } from './index.Cp00ESn6.js';
import { d as debounce } from './debounce.CJgNZ1TL.js';
import { e as appendPx, o as useStore, a as toPascalCase, _ as __variableDynamicImportRuntimeHelper, h as hexToRgba } from './useStore.B0k3KXLh.js';
import { a as termsText, m as modalOpen, t as toggleModal } from './useModal.CtQMkYkB.js';
import { _ as _sfc_main$g } from './XClose.vue_vue_type_style_index_0_lang.8cS4YnbD.js';
import { _ as _sfc_main$c } from './Overlay.vue_vue_type_style_index_0_lang.ClKc0F1i.js';
import { _ as _sfc_main$d } from './Back.vue_vue_type_style_index_0_lang.CN582q2P.js';
import { _ as _sfc_main$e } from './Steps.vue_vue_type_style_index_0_lang.C4lMIBY7.js';
import { _ as _sfc_main$f } from './Modal.vue_vue_type_style_index_0_lang.BzBEou5F.js';
import { u as useImageAttrs, _ as _sfc_main$h, a as useImageStyles, i as icon } from './useImageStyles.BEVtIsp6.js';
import { _ as _export_sfc } from './_plugin-vue_export-helper.pcqpp-6-.js';
import { b as _sfc_main$j } from './Text.vue_vue_type_style_index_0_lang.CFVGfjC7.js';
import { _ as _sfc_main$i } from './Icon.vue_vue_type_style_index_0_lang.CN5YDA-L.js';
import { u as useI18n } from './widgets-core.es.C7uAbUpp.js';

const _hoisted_1$b = { class: "thn--tool-circular__content" };
const _hoisted_2$4 = { class: "thn--tool-circular__popup" };
const popupDefaultWidth = 530;
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "Circular",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "573aac12": unref(appendPx)(popupWidth.value)
    }));
    debounce(toggleModal, 200, { leading: true, trailing: false });
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const { width: rootWidth, height: rootHeight } = useElementSize(rootDom);
    const popupWidth = computed(() => {
      const minRootSize = Math.min(rootWidth.value, rootHeight.value);
      return Math.min(popupDefaultWidth, minRootSize * 0.9);
    });
    const maxHeight = computed(() => popupWidth.value);
    const closeOnClickOutside = computed(() => !!props.layout.closeOnClickOutside);
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "100px 75px 100px 60px",
          "--module-margin-top": "20px",
          "--xclose-margin": "0px"
        } : {
          "--step-padding": "70px 45px 40px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-circular",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-circular__overlay",
              "close-on-click-outside": closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createElementVNode("div", _hoisted_1$b, [
              createVNode(Transition, { name: "fade-from-bottom" }, {
                default: withCtx(() => [
                  withDirectives(createElementVNode("div", _hoisted_2$4, [
                    createVNode(_sfc_main$d, { class: "thn--tool-circular__back" }),
                    createVNode(_sfc_main$e, {
                      class: "thn--tool-circular__steps",
                      steps: props.steps,
                      "has-extra-steps": props.hasSteps,
                      "max-height": maxHeight.value,
                      "modal-root-container": _ctx.modalRootContainer
                    }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
                    createVNode(Transition, { name: "fade" }, {
                      default: withCtx(() => [
                        withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                          [vShow, unref(modalOpen)]
                        ])
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [vShow, !hidden.value && entertransitionEnded.value]
                  ])
                ]),
                _: 1
              }),
              createVNode(Transition, { name: "fade" }, {
                default: withCtx(() => [
                  withDirectives(createVNode(_sfc_main$g, null, null, 512), [
                    [vShow, !hidden.value && !unref(modalOpen) && entertransitionEnded.value]
                  ])
                ]),
                _: 1
              })
            ])
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$a = ["data-device"];
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "CustomImage",
  props: {
    language: {},
    device: {},
    steps: {},
    layout: {}
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "5cab15f2": heightCustomImage.value,
      "2a42a60a": maxHeightCustomImage.value,
      "39f67be5": xClosePosition.value
    }));
    const props = __props;
    const store = useStore();
    const rootDom = ref();
    const hidden = ref(false);
    const imageLoaded = ref(false);
    const xClosePosition = ref("-40px");
    const { width, height } = useElementSize(rootDom);
    const layoutComp = computed(() => props.layout);
    const deviceComp = computed(() => props.device);
    const { imageUrl } = useImageAttrs(layoutComp, deviceComp);
    const closeOnClickOutside = computed(() => !!props.layout.closeOnClickOutside);
    const imageModuleProps = computed(() => props.steps[DefaultStep.Main][0]);
    const maxImageWidth = computed(() => {
      if (width.value) {
        const multiplier = store?.literals.device === DeviceKind.Mobile ? 0.9 : 0.8;
        return width.value * multiplier;
      }
      return 300;
    });
    const maxImageHeight = computed(() => {
      if (height.value) {
        const multiplier = store?.literals.device === DeviceKind.Mobile ? 0.9 : 0.8;
        return height.value * multiplier;
      }
      return 300;
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    const heightCustomImage = ref("auto");
    const maxHeightCustomImage = ref("auto");
    const calculateImageHeight = (imageHeight) => {
      heightCustomImage.value = imageHeight > window.innerHeight * 0.9 ? "100%" : "auto";
      maxHeightCustomImage.value = imageHeight > window.innerHeight * 0.9 ? "90dvh" : "auto";
    };
    const calculateCloseButtonPosition = (imageWidth) => {
      if (store?.literals.device === DeviceKind.Mobile) return;
      if (imageWidth >= width.value - 90) {
        xClosePosition.value = "1rem";
      } else {
        xClosePosition.value = "-40px";
      }
    };
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: ""
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-custom-image",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-custom-image__overlay",
              "close-on-click-outside": closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createElementVNode("div", {
              class: "thn--tool__popup thn--tool-custom-content",
              "data-add-module": true,
              "data-device": _ctx.device
            }, [
              createVNode(_sfc_main$h, {
                class: "thn--tool-custom-image__image",
                "module-props": imageModuleProps.value,
                "max-width": maxImageWidth.value,
                "max-height": maxImageHeight.value,
                onNaturalImageHeight: calculateImageHeight,
                onImageWidth: calculateCloseButtonPosition,
                onImageLoad: _cache[0] || (_cache[0] = (isLoaded) => imageLoaded.value = isLoaded)
              }, null, 8, ["module-props", "max-width", "max-height"]),
              createVNode(_sfc_main$g)
            ], 8, _hoisted_1$a)
          ], 512), [
            [vShow, !hidden.value && (imageLoaded.value || !unref(imageUrl))]
          ])
        ]),
        _: 1
      });
    };
  }
});

const CustomImage = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-1e5a1fb3"]]);

const _hoisted_1$9 = { class: "thn--tool-fullscreen__popup" };
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "Fullscreen",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const maxHeight = computed(() => {
      if (rootDom.value) {
        return rootDom.value.offsetHeight;
      }
      return void 0;
    });
    const closeOnClickOutside = computed(() => props.layout.closeOnClickOutside);
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-fullscreen",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-fullscreen__overlay",
              "close-on-click-outside": !!closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createVNode(Transition, { name: "fade-from-bottom" }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", _hoisted_1$9, [
                  createVNode(_sfc_main$e, {
                    class: "thn--tool-fullscreen__steps",
                    steps: props.steps,
                    "has-extra-steps": props.hasSteps,
                    "max-height": maxHeight.value,
                    "modal-root-container": _ctx.modalRootContainer
                  }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
                  createVNode(Transition, { name: "fade" }, {
                    default: withCtx(() => [
                      withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                        [vShow, unref(modalOpen)]
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            }),
            !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 0 })) : createCommentVNode("", true)
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$8 = ["data-device"];
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "FullscreenMini",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const maxHeight = computed(() => {
      if (rootDom.value) {
        return rootDom.value.offsetHeight;
      }
      return void 0;
    });
    const closeOnClickOutside = computed(() => props.layout.closeOnClickOutside);
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "20px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-fullscreen-mini",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-fullscreen-mini__overlay",
              "close-on-click-outside": !!closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createVNode(Transition, { name: "fade-from-bottom" }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", {
                  class: "thn--tool-fullscreen-mini__popup",
                  "data-device": unref(store)?.literals.device
                }, [
                  createVNode(_sfc_main$e, {
                    class: "thn--tool-fullscreen-mini__steps",
                    steps: props.steps,
                    "has-extra-steps": props.hasSteps,
                    "max-height": maxHeight.value,
                    "modal-root-container": _ctx.modalRootContainer
                  }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
                  createVNode(Transition, { name: "fade" }, {
                    default: withCtx(() => [
                      withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                        [vShow, unref(modalOpen)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_1$8), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            }),
            !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 0 })) : createCommentVNode("", true)
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$7 = ["data-device"];
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "LowerNotification",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const rootDom = ref();
    const stepActive = computed(() => store?.handlers.stepActive || DefaultStep.Main);
    const isMobile = computed(() => store?.literals.device === DeviceKind.Mobile);
    const moduleCount = computed(() => props.steps[DefaultStep.Main].filter(
      (module) => module.moduleType !== ToolModuleKind.Icon
    ).length);
    const iconProps = computed(() => props.steps[DefaultStep.Main].find(
      (module) => module.moduleType === ToolModuleKind.Icon
    ));
    const buttonProps = computed(() => props.steps[stepActive.value].find(
      (module) => module.moduleType === ToolModuleKind.Button
    ));
    const hasFormModule = computed(() => !!props.steps[DefaultStep.Main].find(
      (module) => module.moduleType === ToolModuleKind.Form
    ));
    const verticalModules = ["savedSearch", "emailCapture", "countdown", "perks"];
    const specialModulesCount = computed(() => props.steps[DefaultStep.Main].filter(
      (module) => verticalModules.includes(module.moduleType)
    ).length);
    const isHorizontalLayout = computed(() => moduleCount.value > 4 || hasFormModule.value || specialModulesCount.value >= 2);
    const filteredSteps = computed(() => {
      const returnSteps = Object.keys(props.steps).reduce((stepsObj, stepId) => {
        stepsObj[stepId] = props.steps[stepId].filter((module) => {
          const isIcon = module.moduleType === ToolModuleKind.Icon;
          const isButton = module.moduleType === ToolModuleKind.Button;
          const isText = [
            ToolModuleKind.Paragraph,
            ToolModuleKind.Heading
          ].includes(module.moduleType);
          if (isIcon) return false;
          if (isButton) return isHorizontalLayout.value || isMobile.value;
          if (isText) return isHorizontalLayout.value || isMobile.value;
          return true;
        });
        return stepsObj;
      }, {});
      return returnSteps;
    });
    const filteredTexts = computed(() => {
      const returnSteps = Object.keys(props.steps).reduce((stepsObj, stepId) => {
        stepsObj[stepId] = props.steps[stepId].filter(
          (module) => module.moduleType === ToolModuleKind.Paragraph || module.moduleType === ToolModuleKind.Heading
        );
        return stepsObj;
      }, {});
      return returnSteps;
    });
    const maxHeight = computed(() => {
      if (rootDom.value) {
        return isMobile.value ? 0 : 270;
      }
      return void 0;
    });
    watchEffect(() => {
      store?.styles.addCssVariables(
        isMobile.value ? {
          "--step-padding": "5px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--module-margin-top": "10px",
          "--step-padding": `5px 15px 10px ${iconProps.value ? 20 : 0}px`,
          "--xclose-margin": "7px"
        }
      );
    });
    const matchingSteps = computed(() => filteredSteps.value.main.filter((step) => ["countdown", "perks", "savedSearch", "emailCapture"].includes(step.moduleType)));
    const alignModuleType = computed(() => matchingSteps.value?.length ? matchingSteps.value?.[0]?.moduleType : null);
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade-from-bottom",
        appear: ""
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-lower-notification",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createElementVNode("div", {
              class: "thn--tool-lower-notification__popup",
              "data-device": unref(store)?.literals.device
            }, [
              createVNode(_sfc_main$d, { class: "thn--tool-lower-notification__back" }),
              iconProps.value && !isMobile.value ? (openBlock(), createBlock(_sfc_main$i, {
                key: 0,
                class: "thn--tool-lower-notification__icon",
                "module-props": iconProps.value,
                "data-align": unref(store)?.literals.device === "desktop" ? alignModuleType.value : null
              }, null, 8, ["module-props", "data-align"])) : createCommentVNode("", true),
              createVNode(_sfc_main$e, {
                class: "thn--tool-lower-notification__steps",
                steps: filteredSteps.value,
                texts: filteredTexts.value,
                "has-extra-steps": props.hasSteps,
                "max-height": maxHeight.value,
                "layout-kind": unref(ToolLayoutKind).LowerNotification,
                "is-horizontal-layout": unref(store)?.literals.device === "desktop" && !isHorizontalLayout.value,
                "module-align": alignModuleType.value,
                "modal-root-container": _ctx.modalRootContainer
              }, null, 8, ["steps", "texts", "has-extra-steps", "max-height", "layout-kind", "is-horizontal-layout", "module-align", "modal-root-container"]),
              buttonProps.value && !isMobile.value && !isHorizontalLayout.value ? (openBlock(), createBlock(_sfc_main$j, {
                key: 1,
                class: "thn--tool-lower-notification__button",
                "module-props": buttonProps.value,
                "has-extra-steps": props.hasSteps,
                "data-module-id": buttonProps.value.id,
                "data-module-special": true,
                "data-align": unref(store)?.literals.device === "desktop" ? alignModuleType.value : null
              }, null, 8, ["module-props", "has-extra-steps", "data-module-id", "data-align"])) : createCommentVNode("", true),
              !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, {
                key: 2,
                class: "thn--tool-lower-notification__xclose"
              })) : createCommentVNode("", true),
              createVNode(Transition, { name: "fade" }, {
                default: withCtx(() => [
                  withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                    [vShow, unref(modalOpen)]
                  ])
                ]),
                _: 1
              })
            ], 8, _hoisted_1$7)
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$6 = ["data-position"];
const _hoisted_2$3 = ["data-closed"];
const _hoisted_3$2 = ["data-show-number", "disabled", "aria-expanded", "aria-label"];
const marginX = 40;
const MAX_HEIGHT_RATIO = 0.6;
const MAX_HEIGHT_THRESHOLD = 620;
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "NotificationTab",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  emits: [
    "after-leave"
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
    useCssVars((_ctx) => ({
      "2658c67c": unref(appendPx)(marginX),
      "7258706c": unref(appendPx)(maxWidth.value)
    }));
    const { t } = useI18n();
    const props = __props;
    const emit = __emit;
    const closed = ref(true);
    const sizerDom = ref();
    const { width, height } = useElementSize(sizerDom);
    const store = useStore();
    const entertransitionEnded = ref(false);
    const isLowerPosition = computed(() => props.layout.position?.charAt(0) === "L");
    const IconComponent = computed(() => {
      if (props.layout.icon?.value) {
        const iconComponentName = `${toPascalCase(props.layout.icon.value)}Icon`;
        return defineAsyncComponent(() => __variableDynamicImportRuntimeHelper((/* #__PURE__ */ Object.assign({"../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidAppleIcon.js": () => import('./AndroidAppleIcon.B9zoMwvD.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/AndroidIcon.js": () => import('./AndroidIcon.Amc6Tg4a.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/AppleIcon.js": () => import('./AppleIcon.B9ji2OiQ.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/AutumnIcon.js": () => import('./AutumnIcon.jjZ1ZD5u.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BabyBottleIcon.js": () => import('./BabyBottleIcon.UiWjjRv6.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BaliBedIcon.js": () => import('./BaliBedIcon.BwJ3dbq2.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BathtubIcon.js": () => import('./BathtubIcon.CIRA-o0C.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeachballIcon.js": () => import('./BeachballIcon.qzk7cfpZ.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BeerIcon.js": () => import('./BeerIcon.BsQK3dhU.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BellIcon.js": () => import('./BellIcon.CwlV9Jyf.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BicycleIcon.js": () => import('./BicycleIcon.BaN-9zPB.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BikeIcon.js": () => import('./BikeIcon.Dt_HDmYa.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BinocularsIcon.js": () => import('./BinocularsIcon.BLY722DL.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BoatIcon.js": () => import('./BoatIcon.CyT8vyCF.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/Book2Icon.js": () => import('./Book2Icon.C-O_vVWW.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BookIcon.js": () => import('./BookIcon.B0ZdqMWI.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BreadIcon.js": () => import('./BreadIcon.Slz1oWw3.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BriefcaseIcon.js": () => import('./BriefcaseIcon.DUxP8Qa9.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusIcon.js": () => import('./BusIcon.DzE8MS8-.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BusNewIcon.js": () => import('./BusNewIcon.CaW_7Znl.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/BycicleIcon.js": () => import('./BycicleIcon.CplUta1G.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CactusIcon.js": () => import('./CactusIcon.BEBBA1l3.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CakeIcon.js": () => import('./CakeIcon.DAVraTkj.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CalendarIcon.js": () => import('./CalendarIcon.oj_AoWGb.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CameraIcon.js": () => import('./CameraIcon.1eygWNMO.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarIcon.js": () => import('./CarIcon.CKlkoyXC.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarNewIcon.js": () => import('./CarNewIcon.K-_yKybg.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CarrotIcon.js": () => import('./CarrotIcon.zklYvfa7.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CheckIcon.js": () => import('./CheckIcon.hTZcJKEr.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ChurchIcon.js": () => import('./ChurchIcon.5y3D5ReD.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ClockIcon.js": () => import('./ClockIcon.C_69DgLm.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CocktailIcon.js": () => import('./CocktailIcon.DdArSoAZ.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CoffeeIcon.js": () => import('./CoffeeIcon.ByzWiJ6S.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/CupsIcon.js": () => import('./CupsIcon.VfnR6wfS.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/DangerIcon.js": () => import('./DangerIcon.B2fq9Rga.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/DiscountIcon.js": () => import('./DiscountIcon.CMfUTW1a.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/DownloadMobileIcon.js": () => import('./DownloadMobileIcon.DhPqB3Aw.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/EggIcon.js": () => import('./EggIcon.1E2wZ_EF.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/EnvelopeIcon.js": () => import('./EnvelopeIcon.CROjaQQm.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/FacebookIcon.js": () => import('./FacebookIcon.Bv2dWlJV.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/FamilyIcon.js": () => import('./FamilyIcon.DzZZQ1a_.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/FlipFlopsIcon.js": () => import('./FlipFlopsIcon.BDz7ZjPt.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/GhostIcon.js": () => import('./GhostIcon.DxvK5IJn.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/GiftIcon.js": () => import('./GiftIcon.D3X286j6.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/GolfIcon.js": () => import('./GolfIcon.BVCIN-Jp.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphIcon.js": () => import('./GraphIcon.BFuyvuw2.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/GraphUpIcon.js": () => import('./GraphUpIcon.CorVRRK1.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/GymIcon.js": () => import('./GymIcon.Bt22HcLj.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HalloweenIcon.js": () => import('./HalloweenIcon.DigOsLvU.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HamburgerIcon.js": () => import('./HamburgerIcon.BvyRlQKo.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HandShakeIcon.js": () => import('./HandShakeIcon.CzWjHY3I.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HashtagIcon.js": () => import('./HashtagIcon.BiW8MhpK.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartIcon.js": () => import('./HeartIcon.BERou0mg.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsIcon.js": () => import('./HeartsIcon.Bh8w_0gv.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HeartsNewIcon.js": () => import('./HeartsNewIcon.DbUcTOFt.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/HotelIcon.js": () => import('./HotelIcon.CLuJQmww.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/InformationIcon.js": () => import('./InformationIcon.CFxQxHU5.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/InstagramIcon.js": () => import('./InstagramIcon.Bo6bdjqH.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastReservationIcon.js": () => import('./LastReservationIcon.BQ50gXsu.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/LastWeekStayedIcon.js": () => import('./LastWeekStayedIcon.BdN7evK1.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/LaundryIcon.js": () => import('./LaundryIcon.DG2YavBY.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/LightIcon.js": () => import('./LightIcon.DysZPDw_.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/LockGreatPriceIcon.js": () => import('./LockGreatPriceIcon.Bfl_ZaWx.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/MaskIcon.js": () => import('./MaskIcon.BHdu4j33.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/MusicIcon.js": () => import('./MusicIcon.CRqQmTS4.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PalmIcon.js": () => import('./PalmIcon.iFqU6-4F.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingCarIcon.js": () => import('./ParkingCarIcon.cel8efpi.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ParkingPIcon.js": () => import('./ParkingPIcon.BP-wddr9.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PawIcon.js": () => import('./PawIcon.DNvF48jO.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PictureIcon.js": () => import('./PictureIcon.D6AUeeAu.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PinIcon.js": () => import('./PinIcon.CAh_8MHw.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PizzaIcon.js": () => import('./PizzaIcon.263s7Icr.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlaneIcon.js": () => import('./PlaneIcon.DqEQLED0.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PlatterIcon.js": () => import('./PlatterIcon.D1zJyikd.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PoolIcon.js": () => import('./PoolIcon.DFidVe6Q.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/PrizeIcon.js": () => import('./PrizeIcon.DgCOzv-9.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/RabbitIcon.js": () => import('./RabbitIcon.T5s8_Nej.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/RaceIcon.js": () => import('./RaceIcon.CyWmUAVv.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/RelaxIcon.js": () => import('./RelaxIcon.38wT1NDq.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/RestaurantIcon.js": () => import('./RestaurantIcon.kQzAL9Pn.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ReviewsIcon.js": () => import('./ReviewsIcon.DK5ytV3k.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoomIcon.js": () => import('./RoomIcon.-EoCge0V.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/RoseIcon.js": () => import('./RoseIcon.WPkWbC1v.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SantaIcon.js": () => import('./SantaIcon.D1lCe-jM.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceDollarIcon.js": () => import('./SecurePriceDollarIcon.C8NFz1iQ.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceEuroIcon.js": () => import('./SecurePriceEuroIcon.CacbFIc8.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceIcon.js": () => import('./SecurePriceIcon.C8NFz1iQ.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePricePoundIcon.js": () => import('./SecurePricePoundIcon.CTzzt-28.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SecurePriceYenIcon.js": () => import('./SecurePriceYenIcon.gl2feVTx.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ShoppingIcon.js": () => import('./ShoppingIcon.Bxw-0aHj.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SkiIcon.js": () => import('./SkiIcon.Cf2OZcMk.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SnowIcon.js": () => import('./SnowIcon.ClB-i5X0.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpacerIcon.js": () => import('./SpacerIcon.DrAZLe3o.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SpecialIcon.js": () => import('./SpecialIcon.DU3lGfrC.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/StarIcon.js": () => import('./StarIcon.C7fGJn5y.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SunIcon.js": () => import('./SunIcon.CM9E5f7O.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/SurfIcon.js": () => import('./SurfIcon.BBGbn8fa.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/ThunderIcon.js": () => import('./ThunderIcon.D2avy2I8.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/TieIcon.js": () => import('./TieIcon.B3uy1kDO.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/TreeIcon.js": () => import('./TreeIcon.tPrQAQtQ.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/TripadvisorIcon.js": () => import('./TripadvisorIcon.xd1Hz3a2.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/TrophyIcon.js": () => import('./TrophyIcon.BUOYLZkK.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/TvIcon.js": () => import('./TvIcon.CppM2WHY.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/UserIcon.js": () => import('./UserIcon.D49xJS9v.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersIcon.js": () => import('./UsersIcon.Dn9zIyku.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/UsersNewIcon.js": () => import('./UsersNewIcon.BZN0bCjt.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/VirusIcon.js": () => import('./VirusIcon.G0n8fiPc.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/VoucherIcon.js": () => import('./VoucherIcon.BLYARNy1.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/WeddingIcon.js": () => import('./WeddingIcon.Dv-1u9Yr.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/WhatsappIcon.js": () => import('./WhatsappIcon.D77qFYDF.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/WheelchairIcon.js": () => import('./WheelchairIcon.BrRD44nj.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/WifiIcon.js": () => import('./WifiIcon.V658SURC.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/WineIcon.js": () => import('./WineIcon.DY20zYA0.js'),"../../node_modules/@thehotelsnetwork/icons/vue/personalization/index.js": () => import('./index.B8WAmiiC.js')})), `../../node_modules/@thehotelsnetwork/icons/vue/personalization/${iconComponentName}.js`, 8));
      }
      return null;
    });
    const ChevronComponent = computed(() => defineAsyncComponent(() => isLowerPosition.value ? import('./ChevronDownIcon.DvLXO2AZ.js') : import('./ChevronUpIcon.DfqEL4Cu.js')));
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "32px 45px 32px 32px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px 40px 25px 25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    const isMidPosition = computed(() => props.layout.position === "UML" || props.layout.position === "UMR" || props.layout.position === "LML" || props.layout.position === "LMR");
    const maxWidth = computed(() => {
      if (width.value) {
        return width.value - 2 * marginX;
      }
      return 0;
    });
    const maxHeight = computed(() => {
      if (height.value && isMidPosition.value) {
        return height.value * MAX_HEIGHT_RATIO;
      }
      if (height.value) {
        return height.value > MAX_HEIGHT_THRESHOLD ? MAX_HEIGHT_THRESHOLD : height.value * MAX_HEIGHT_RATIO;
      }
      return 0;
    });
    const animationName = computed(() => {
      let animationDirection = "up";
      if (isLowerPosition.value && closed.value || !isLowerPosition.value && !closed.value) {
        animationDirection = "down";
      }
      return `fade-tab-icon-${animationDirection}`;
    });
    function show() {
      closed.value = false;
    }
    function hide() {
      closed.value = true;
      emit("after-leave");
    }
    const openClose = debounce(() => {
      closed.value = !closed.value;
    }, 200, { leading: true, trailing: false });
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    watchEffect(() => {
      if (store?.extraData.builderMode) {
        setTimeout(() => {
          closed.value = false;
        }, 500);
      }
    });
    onMounted(() => {
      if (props.layout.showOpen) {
        setTimeout(() => {
          closed.value = false;
        }, 1e3);
      }
    });
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: "thn--tool-notification-tab__sizer",
          ref_key: "sizerDom",
          ref: sizerDom
        }, null, 512),
        createElementVNode("div", {
          class: "thn--tool-notification-tab",
          "data-position": _ctx.layout.position
        }, [
          createElementVNode("div", {
            class: "thn--tool-notification-tab__popup",
            "data-closed": closed.value
          }, [
            createVNode(_sfc_main$d, { class: "thn--tool-notification-tab__back" }),
            createVNode(_sfc_main$e, {
              class: "thn--tool-notification-tab__steps",
              steps: props.steps,
              "has-extra-steps": props.hasSteps,
              "max-height": maxHeight.value,
              "modal-root-container": _ctx.modalRootContainer
            }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
            createVNode(_sfc_main$g, {
              "trigger-dismiss": false,
              onMousedown: withModifiers(unref(openClose), ["left"]),
              onClick: unref(openClose)
            }, null, 8, ["onMousedown", "onClick"]),
            createVNode(Transition, {
              name: "fade",
              appear: "",
              onAfterEnter: onAfterEnterTransition
            }, {
              default: withCtx(() => [
                withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                  [vShow, unref(modalOpen)]
                ])
              ]),
              _: 1
            })
          ], 8, _hoisted_2$3),
          createElementVNode("button", {
            type: "button",
            class: "thn--tool-notification-tab__tab",
            onClick: _cache[0] || (_cache[0] = //@ts-ignore
            (...args) => unref(openClose) && unref(openClose)(...args)),
            "data-show-number": closed.value,
            disabled: unref(store)?.extraData.builderMode,
            "aria-expanded": !closed.value,
            "aria-label": unref(t)("Expand notification")
          }, [
            createVNode(Transition, { name: animationName.value }, {
              default: withCtx(() => [
                closed.value || unref(store)?.extraData.builderMode ? (openBlock(), createBlock(unref(IconComponent), {
                  key: 0,
                  class: "thn--tool-notification-tab__icon",
                  "aria-hidden": "true"
                })) : !closed.value ? (openBlock(), createBlock(unref(ChevronComponent), {
                  key: 1,
                  class: "thn--tool-notification-tab__icon",
                  "aria-hidden": "true"
                })) : createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["name"])
          ], 8, _hoisted_3$2)
        ], 8, _hoisted_1$6)
      ], 64);
    };
  }
});

const NotificationTab = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["__scopeId", "data-v-4ba31d55"]]);

const _hoisted_1$5 = ["data-layout-position", "data-size", "data-device"];
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "Sidebar",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const popupDom = ref();
    const maxHeight = computed(() => {
      if (rootDom.value) {
        const multiplier = props.layout.position === ToolPosition.Bottom ? 0.5 : 1;
        return rootDom.value.offsetHeight * multiplier;
      }
      return void 0;
    });
    const closeOnClickOutside = computed(() => props.layout.closeOnClickOutside);
    const transitionName = computed(() => {
      switch (props.layout.position) {
        case ToolPosition.Left:
          return "fade-from-left";
        case ToolPosition.Right:
          return "fade-from-right";
        case ToolPosition.Bottom:
        default:
          return "fade-from-bottom";
      }
    });
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-sidebar",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-sidebar__overlay",
              "close-on-click-outside": !!closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createVNode(Transition, { name: transitionName.value }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", {
                  class: "thn--tool-sidebar__popup",
                  ref_key: "popupDom",
                  ref: popupDom,
                  "data-layout-position": props.layout.position,
                  "data-size": props.layout.size,
                  "data-device": props.device
                }, [
                  createVNode(_sfc_main$d, { class: "thn--tool-sidebar__back" }),
                  createVNode(_sfc_main$e, {
                    class: "thn--tool-sidebar__steps",
                    steps: props.steps,
                    "has-extra-steps": props.hasSteps,
                    "max-height": maxHeight.value,
                    "modal-root-container": _ctx.modalRootContainer
                  }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
                  !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 0 })) : createCommentVNode("", true),
                  createVNode(Transition, { name: "fade" }, {
                    default: withCtx(() => [
                      withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                        [vShow, unref(modalOpen)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_1$5), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            }, 8, ["name"])
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$4 = ["data-size", "data-position"];
const _hoisted_2$2 = { class: "thn--tool-side-gradient__content" };
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "SideGradient",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "f5c9f57e": backgroundGradient.value
    }));
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const rootDom = ref();
    const maxHeight = computed(() => {
      if (rootDom.value) {
        const multiplier = props.layout.position === ToolPosition.Bottom ? 0.5 : 1;
        return rootDom.value.offsetHeight * multiplier;
      }
      return void 0;
    });
    const backgroundGradient = computed(() => {
      const {
        base = "#ffffff",
        gradient
      } = store?.styles.colors.background || {};
      let angle;
      switch (props.layout.position) {
        case ToolPosition.Bottom:
          angle = 360;
          break;
        case ToolPosition.Right:
          angle = -90;
          break;
        default:
          angle = 90;
          break;
      }
      const colors = store?.rtl && props.layout.position !== ToolPosition.Bottom ? `${hexToRgba(gradient || base, 0)} 0%, 
       ${hexToRgba(gradient || base, 0.75)} 41.36%, 
       ${hexToRgba(base, 0.95)} 71.2%, 
       ${base} 99.93%` : `${base} 0.07%, 
       ${hexToRgba(base, 0.95)} 28.8%, 
       ${hexToRgba(gradient || base, 0.75)} 58.64%, 
       ${hexToRgba(gradient || base, 0)} 100%`;
      const value = `linear-gradient(${angle}deg, ${colors})`;
      return value;
    });
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: ""
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-side-gradient",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createElementVNode("div", {
              class: "thn--tool-side-gradient__popup",
              "data-size": props.layout.size,
              "data-position": props.layout.position
            }, [
              createElementVNode("div", _hoisted_2$2, [
                createVNode(_sfc_main$e, {
                  class: "thn--tool-side-gradient__steps",
                  steps: props.steps,
                  "has-extra-steps": props.hasSteps,
                  "max-height": maxHeight.value,
                  layout: props.layout,
                  "modal-root-container": _ctx.modalRootContainer
                }, null, 8, ["steps", "has-extra-steps", "max-height", "layout", "modal-root-container"]),
                !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, {
                  key: 0,
                  class: "thn--tool-side-gradient__xclose"
                })) : createCommentVNode("", true),
                createVNode(Transition, { name: "fade" }, {
                  default: withCtx(() => [
                    withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                      [vShow, unref(modalOpen)]
                    ])
                  ]),
                  _: 1
                })
              ])
            ], 8, _hoisted_1$4)
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$3 = { class: "thn--tool-square__popup" };
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "Square",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const maxHeight = computed(() => {
      if (rootDom.value) {
        return rootDom.value.offsetHeight * 0.8;
      }
      return void 0;
    });
    const closeOnClickOutside = computed(() => !!props.layout.closeOnClickOutside);
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-square",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-square__overlay",
              "close-on-click-outside": closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createVNode(Transition, { name: "fade-from-bottom" }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", _hoisted_1$3, [
                  createVNode(_sfc_main$d, { class: "thn--tool-square__back" }),
                  createVNode(_sfc_main$e, {
                    class: "thn--tool-square__steps",
                    steps: props.steps,
                    "has-extra-steps": props.hasSteps,
                    "max-height": maxHeight.value,
                    "modal-root-container": _ctx.modalRootContainer
                  }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
                  !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 0 })) : createCommentVNode("", true),
                  createVNode(Transition, { name: "fade" }, {
                    default: withCtx(() => [
                      withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                        [vShow, unref(modalOpen)]
                      ])
                    ]),
                    _: 1
                  })
                ], 512), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$2 = ["data-loaded"];
const _hoisted_2$1 = ["src", "alt"];
const _hoisted_3$1 = { class: "w-full h-full bg-base-300 flex items-center justify-center" };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "SquareImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const { t } = useI18n();
    const store = useStore();
    const props = __props;
    const rootDom = ref();
    const imageLoaded = ref(false);
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const layoutComp = computed(() => props.layout);
    const deviceComp = computed(() => props.device);
    const { imageUrl, imageAlt } = useImageAttrs(layoutComp, deviceComp);
    const maxHeight = computed(() => {
      if (rootDom.value) {
        const multiplier = props.device === DeviceKind.Mobile ? 0.4 : 0.8;
        return rootDom.value.offsetHeight * multiplier;
      }
      return void 0;
    });
    const closeOnClickOutside = computed(() => !!props.layout.closeOnClickOutside);
    const imagePosition = computed(() => {
      if (props.device === DeviceKind.Mobile) {
        return "top";
      }
      return props.layout?.imagePosition ?? "left";
    });
    const { imageStyles } = useImageStyles(
      computed(() => props.layout),
      computed(() => props.device),
      imagePosition
    );
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "40px",
          "--module-margin-top": "20px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
      if (!imageUrl.value) {
        imageLoaded.value = false;
      }
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    function onLoadImage() {
      imageLoaded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        onAfterEnter: onAfterEnterTransition,
        appear: ""
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-square-image",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(_sfc_main$c, {
              class: "thn--tool-square-image__overlay",
              "close-on-click-outside": closeOnClickOutside.value
            }, null, 8, ["close-on-click-outside"]),
            createVNode(Transition, { name: "fade-from-bottom" }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", {
                  class: normalizeClass([
                    "thn--tool-square-image__popup",
                    imagePosition.value
                  ])
                }, [
                  unref(imageStyles) ? (openBlock(), createBlock(_sfc_main$d, {
                    key: 0,
                    class: "thn--tool-square-image__back"
                  })) : createCommentVNode("", true),
                  createElementVNode("div", {
                    class: normalizeClass([
                      "thn--tool-square-image__popup__wrapper",
                      imagePosition.value
                    ])
                  }, [
                    createElementVNode("div", {
                      class: "thn--tool-square-image__image",
                      style: normalizeStyle(unref(imageStyles)),
                      "data-loaded": imageLoaded.value
                    }, [
                      createVNode(TransitionGroup, { name: "fade" }, {
                        default: withCtx(() => [
                          withDirectives(createElementVNode("img", {
                            ref: "imageDOM",
                            src: unref(imageUrl),
                            onLoad: onLoadImage,
                            alt: unref(imageAlt)
                          }, null, 40, _hoisted_2$1), [
                            [vShow, imageLoaded.value]
                          ]),
                          withDirectives(createElementVNode("div", _hoisted_3$1, [
                            createVNode(unref(icon), {
                              class: "img-icon",
                              alt: unref(t)("Picture icon")
                            }, null, 8, ["alt"])
                          ], 512), [
                            [vShow, !imageLoaded.value]
                          ])
                        ]),
                        _: 1
                      })
                    ], 12, _hoisted_1$2),
                    createElementVNode("div", {
                      class: normalizeClass(["thn--tool-square-image__content", [{ "relative": imageLoaded.value }]])
                    }, [
                      !unref(imageStyles) ? (openBlock(), createBlock(_sfc_main$d, {
                        key: 0,
                        class: "thn--tool-square-image__back"
                      })) : createCommentVNode("", true),
                      createVNode(_sfc_main$e, {
                        class: "thn--tool-square-image__steps",
                        steps: props.steps,
                        "has-extra-steps": props.hasSteps,
                        "max-height": maxHeight.value,
                        "layout-kind": unref(ToolLayoutKind).SquareImage,
                        "image-position": imagePosition.value,
                        "modal-root-container": _ctx.modalRootContainer
                      }, null, 8, ["steps", "has-extra-steps", "max-height", "layout-kind", "image-position", "modal-root-container"])
                    ], 2),
                    !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 0 })) : createCommentVNode("", true),
                    createVNode(Transition, { name: "fade" }, {
                      default: withCtx(() => [
                        withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                          [vShow, unref(modalOpen)]
                        ])
                      ]),
                      _: 1
                    })
                  ], 2)
                ], 2), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            })
          ], 512), [
            [vShow, !hidden.value && (imageLoaded.value || !unref(imageUrl))]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1$1 = ["data-position", "data-size"];
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Sticky",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const store = useStore();
    const hidden = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const maxHeight = computed(() => {
      if (rootDom.value) {
        return rootDom.value.offsetHeight * 0.6;
      }
      return void 0;
    });
    computed(() => !!props.layout.closeOnClickOutside);
    const transitionName = computed(() => {
      const { position } = props.layout;
      if (position) {
        return `fade-from-${position.slice(-1) === "L" ? "left" : "right"}`;
      }
      return "fade";
    });
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": "24px 40px 24px 24px",
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": "24px 40px 24px 24px",
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      );
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-sticky",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(Transition, { name: transitionName.value }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", {
                  class: "thn--tool-sticky__popup",
                  "data-position": _ctx.layout.position,
                  "data-size": props.layout.size
                }, [
                  createVNode(_sfc_main$d, { class: "thn--tool-sticky__back" }),
                  createVNode(_sfc_main$e, {
                    class: "thn--tool-sticky__steps",
                    steps: props.steps,
                    "has-extra-steps": props.hasSteps,
                    "max-height": maxHeight.value,
                    "modal-root-container": _ctx.modalRootContainer
                  }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"]),
                  !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 0 })) : createCommentVNode("", true),
                  createVNode(Transition, { name: "fade" }, {
                    default: withCtx(() => [
                      withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                        [vShow, unref(modalOpen)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_1$1), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            }, 8, ["name"])
          ], 512), [
            [vShow, !hidden.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

const _hoisted_1 = ["data-device", "data-position", "data-size", "data-image-position"];
const _hoisted_2 = { class: "thn--tool-sticky-image__popup__wrapper" };
const _hoisted_3 = ["data-loaded"];
const _hoisted_4 = { class: "image__wrapper" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "w-full h-full bg-base-300 flex items-center justify-center" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "StickyImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    modalRootContainer: {}
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    provide("layout", ref(props.layout));
    const store = useStore();
    const hidden = ref(false);
    const imageLoaded = ref(false);
    const entertransitionEnded = ref(false);
    const rootDom = ref();
    const layoutComp = computed(() => props.layout);
    const deviceComp = computed(() => props.device);
    const { imageUrl, imageAlt } = useImageAttrs(layoutComp, deviceComp);
    const maxHeight = computed(() => {
      if (rootDom.value) {
        return rootDom.value.offsetHeight * 0.6;
      }
      return void 0;
    });
    const transitionName = computed(() => {
      const { position } = props.layout;
      if (position) {
        return `fade-from-${position.slice(-1) === "L" ? "left" : "right"}`;
      }
      return "fade";
    });
    const imagePosition = computed(() => props.layout?.imagePosition ?? "left");
    const { imageStyles } = useImageStyles(
      computed(() => props.layout),
      computed(() => props.device),
      imagePosition
    );
    watchEffect(() => {
      store?.styles.addCssVariables(
        store.literals.device === DeviceKind.Desktop ? {
          "--step-padding": `16px ${imagePosition.value === "left" ? "40px" : "16px"} 16px 16px`,
          "--module-margin-top": "10px",
          "--xclose-margin": "5px"
        } : {
          "--step-padding": `16px ${imagePosition.value === "left" ? "40px" : "16px"} 16px 16px`,
          "--module-margin-top": "8px",
          "--xclose-margin": "5px"
        }
      );
      if (!imageUrl.value) {
        imageLoaded.value = false;
      }
    });
    function show() {
      hidden.value = false;
    }
    function hide() {
      hidden.value = true;
    }
    function onAfterEnterTransition() {
      entertransitionEnded.value = true;
    }
    function onLoadImage() {
      imageLoaded.value = true;
    }
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "fade",
        appear: "",
        onAfterEnter: onAfterEnterTransition
      }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-sticky-image",
            ref_key: "rootDom",
            ref: rootDom
          }, [
            createVNode(Transition, { name: transitionName.value }, {
              default: withCtx(() => [
                withDirectives(createElementVNode("div", {
                  class: "thn--tool-sticky-image__popup",
                  "data-device": _ctx.device,
                  "data-position": _ctx.layout.position,
                  "data-size": props.layout.size,
                  "data-image-position": imagePosition.value
                }, [
                  createElementVNode("div", _hoisted_2, [
                    unref(imageStyles) ? (openBlock(), createBlock(_sfc_main$d, {
                      key: 0,
                      class: "thn--tool-square-image__back"
                    })) : createCommentVNode("", true),
                    createElementVNode("div", {
                      class: "thn--tool-sticky-image__image",
                      style: normalizeStyle(unref(imageStyles)),
                      "data-loaded": imageLoaded.value
                    }, [
                      createVNode(TransitionGroup, { name: "fade" }, {
                        default: withCtx(() => [
                          withDirectives(createElementVNode("div", _hoisted_4, [
                            createElementVNode("img", {
                              ref: "imageDOM",
                              src: unref(imageUrl),
                              onLoad: onLoadImage,
                              alt: unref(imageAlt)
                            }, null, 40, _hoisted_5)
                          ], 512), [
                            [vShow, imageLoaded.value]
                          ]),
                          withDirectives(createElementVNode("div", _hoisted_6, [
                            createVNode(unref(icon), { class: "img-icon" })
                          ], 512), [
                            [vShow, !imageLoaded.value]
                          ])
                        ]),
                        _: 1
                      })
                    ], 12, _hoisted_3),
                    createElementVNode("div", {
                      class: normalizeClass(["thn--tool-sticky-image__content", [{ "relative": imageLoaded.value }]])
                    }, [
                      !unref(imageStyles) ? (openBlock(), createBlock(_sfc_main$d, {
                        key: 0,
                        class: "thn--tool-square-image__back"
                      })) : createCommentVNode("", true),
                      createVNode(_sfc_main$e, {
                        class: "thn--tool-sticky-image__steps",
                        steps: props.steps,
                        "has-extra-steps": props.hasSteps,
                        "max-height": maxHeight.value,
                        "modal-root-container": _ctx.modalRootContainer
                      }, null, 8, ["steps", "has-extra-steps", "max-height", "modal-root-container"])
                    ], 2),
                    !unref(modalOpen) ? (openBlock(), createBlock(_sfc_main$g, { key: 1 })) : createCommentVNode("", true)
                  ]),
                  createVNode(Transition, { name: "fade" }, {
                    default: withCtx(() => [
                      withDirectives(createVNode(_sfc_main$f, { "terms-text": unref(termsText) }, null, 8, ["terms-text"]), [
                        [vShow, unref(modalOpen)]
                      ])
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_1), [
                  [vShow, !hidden.value && entertransitionEnded.value]
                ])
              ]),
              _: 1
            }, 8, ["name"])
          ], 512), [
            [vShow, !hidden.value && (imageLoaded.value || !unref(imageUrl))]
          ])
        ]),
        _: 1
      });
    };
  }
});

export { CustomImage as C, NotificationTab as N, _sfc_main$b as _, _sfc_main$9 as a, _sfc_main$8 as b, _sfc_main$7 as c, _sfc_main$5 as d, _sfc_main$4 as e, _sfc_main$3 as f, _sfc_main$2 as g, _sfc_main$1 as h, _sfc_main as i };
//# sourceMappingURL=StickyImage.vue_vue_type_style_index_0_lang.CbAoRJs_.js.map
